<template>
  <pageContent class="cookies">
    <div class="cookies-main">
      <div class="row-text">
        <h1 class="font-blod fade-in">Política de Cookies</h1>
      </div>
      <div class="text-center i">
        Esta declaración de cookies fue actualizada por última vez en 1 de Junio
        de 2022 y se aplica a los ciudadanos del Espacio Económico Europeo.
      </div>
      <el-collapse class="collapse" accordion v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> Introducción
          </template>
          <p>
            Nuestro sitio web,
            <el-link href="HTTPS://MARAGONCONSTRUCCION.ES"
              >HTTPS://MARAGONCONSTRUCCION.ES/</el-link
            >(en adelante: “el sitio web”) utiliza cookies y otras tecnologías
            relacionadas (para mayor comodidad, todas las tecnologías se
            denominan “cookies”). Las cookies también son colocadas por terceros
            que hemos contratado. En el siguiente documento le informamos sobre
            el uso de cookies en nuestro sitio web.
          </p>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> ¿Qué son las cookies?
          </template>
          <p>
            Una cookie es un pequeño archivo simple que se envía junto con las
            páginas de este sitio web y que su navegador almacena en el disco
            duro de su orde nador o de otro dispositivo. La información
            almacenada puede ser devuelta a nuestros servidores o a los
            servidores de los terceros relevantes durante una visita posterior.
          </p>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> ¿Qué son los scripts?
          </template>
          <p>
            Un script es un fragmento de código de programa que se utiliza para
            hacer que nuestro sitio web funcione correctamente y de forma
            interactiva. Este código se ejecuta en nuestro servidor o en su
            dispositivo.
          </p>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿Qué es una baliza web?
          </template>
          <p>
            Una baliza web (o una etiqueta de píxel) es una pequeña e invisible
            pieza de texto o imagen en un sitio web que se utiliza para
            monitorear el tráfico en un sitio web. Para ello, se almacenan
            varios datos sobre usted mediante web beacons
          </p>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>Consentimiento
          </template>
          <p>
            Cuando visite nuestro sitio web por primera vez, le mostraremos una
            ventana emergente con una explicación sobre las cookies. Tan pronto
            como haga clic en “Guardar preferencias”, nos autoriza a utilizar
            las categorías de cookies y plugins que seleccionó en la ventana
            emergente, tal y como se describe en esta declaración de cookies.
            Usted puede desactivar el uso de cookies a través de su navegador,
            pero tenga en cuenta que es posible que nuestro sitio web ya no
            funcione correctamente.
          </p>
          <ul>
            <li>Administración de configuración de consentimiento</li>
          </ul>
          <p>
            El usuario tiene el derecho de mostrar su conformidad a través de la
            prestación del consentimiento que solicitaremos al visitar nuestra
            web.
          </p>
          <p>Dicho consentimiento podrá ser modificado en todo momento.</p>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>Cookies
          </template>
          <p style="text-decoration: underline">
            Cookies técnicas o funcionales
          </p>

          <p>
            Algunas cookies aseguran que ciertas partes del sitio web funcionen
            correctamente y que sus preferencias de usuario sigan siendo
            conocidas. Al colocar cookies funcionales, le facilitamos la visita
            a nuestro sitio web. De esta manera, usted no necesita introducir
            repetidamente la misma información cuando visita nuestro sitio web
            y, por ejemplo, los artículos permanecen en su cesta de la compra
            hasta que usted haya pagado. Podemos colocar estas cookies sin su
            consentimiento.
          </p>

          <p style="text-decoration: underline">Cookies analíticas</p>

          <p>
            Son aquéllas que bien tratadas por nosotros o por terceros, nos
            permiten cuantificar el número de usuarios y así realizar la
            medición y análisis estadístico de la utilización que hacen los
            usuarios del servicio ofertado. Para ello se analiza su navegación
            en nuestra página web con el fin de mejorar la oferta de productos o
            servicios que le ofrecemos.
          </p>

          <p style="text-decoration: underline">Cookies de publicidad</p>

          <p>
            Son aquéllas que, bien tratadas por nosotros o por terceros, nos
            permiten gestionar de la forma más eficaz posible la oferta de los
            espacios publicitarios que hay en la página web, adecuando el
            contenido del anuncio al contenido del servicio solicitado o al uso
            que realice de nuestra página web. Para ello po demos analizar sus
            hábitos de navegación en Internet y podemos mostrarle publicidad
            relacionada con su perfil de navegación.
          </p>

          <p style="text-decoration: underline">Botones de medios sociale</p>

          <p>
            En nuestro sitio web hemos incluidos botones para publicitar paginas
            (p.e. “like, “pin”) o compartirlas (p.e. “tweet”) en redes sociales
            como. Estos botones funcionan usando código de ellos mismos. Este
            código incrusta cookies. Estos botones de redes sociales pueden
            almacenar y procesar cierta información, así que se te puede ser
            mostrado un anuncio personalizado.
          </p>
          <p>
            Por favor lee la política de privacidad de estas redes sociales (que
            puede cambiar frecuentemente) para saber que hacen con tus datos
            (personales) que procesan usando estas cookies. Los datos que
            reciben son anonimizados el máximo posible están ubicados en los
            Estados Unidos
          </p>
        </el-collapse-item>
        <el-collapse-item name="7">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>Cookies usadas
          </template>
          <p>
            A continuación le indicamos las cookies utilizadas en este sitio.
            COOKIES CONTROLADAS POR EL EDITOR
          </p>
          <table class="table">
            <tr>
              <th>Cookie</th>
              <th>Dominio</th>
              <th>Tipo</th>
              <th>Descripción</th>
              <th>Duración</th>
            </tr>

            <tr>
              <td>moove_gdpr_popup</td>
              <td>maragonconstruccion.es</td>
              <td>Funcional</td>
              <td>
                Esta cookies se utilizan para guardar sus preferencias de
                configuración de cookies.
              </td>
              <td>1 año</td>
            </tr>
            <tr>
              <td>wordpress_test_cookie</td>
              <td>maragonconstruccion.es</td>
              <td>Funcional</td>
              <td>
                WordPress establece una cookie llamada wordpress_test_cookie
                para verificar si las cookies están habilitadas en el navegador
                para proporcionar una experiencia de usuario adecuada a los
                usuarios. Esta cookie se usa en el front end, incluso si no ha
                iniciado sesión.
              </td>
              <td>Sesión</td>
            </tr>
            <tr>
              <td>elementor</td>
              <td>maragonconstruccion.es</td>
              <td>Necesaria</td>
              <td>
                Esta cookie es utilizada por el tema de WordPress del sitio web.
                Permite al propietario del sitio web implementar o cambiar el
                contenido del sitio web en tiempo real.
              </td>
              <td>Nunca</td>
            </tr>
          </table>
        </el-collapse-item>
        <el-collapse-item name="8">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>Sus derechos con respecto a
            los datos personales
          </template>
          <p>
            Usted tiene los siguientes derechos con respecto a sus datos
            personales:
          </p>

          <ul>
            <li>
              Usted tiene derecho a saber por qué se necesitan sus datos
              personales, qué sucederá con ellos y durante cuánto tiempo se
              conservarán.
            </li>
            <li>
              Derecho de acceso: Usted tiene derecho a acceder a sus datos
              personales que conocemos.
            </li>
            <li>
              Derecho de rectificación: tiene derecho a completar, rectificar,
              borrar o bloquear sus datos personales cuando lo desee.
            </li>
            <li>
              Si usted nos da su consentimiento para procesar sus datos, tiene
              derecho a revocar dicho consentimiento y a que se eliminen sus
              datos personales.
            </li>
            <li>
              Derecho de cesión de sus datos: tiene derecho a solicitar todos
              sus datos personales al responsable del tratamiento y a
              transferirlos íntegramente a otro responsable del tratamiento.
            </li>
            <li>
              Derecho de oposición: usted puede oponerse al tratamiento de sus
              datos. Nosotros cumplimos con esto, a menos que existan motivos
              justificados para el procesamiento.
            </li>
          </ul>
          <p>
            Para ejercer estos derechos, póngase en contacto con nosotros. Por
            favor refiérase a los detalles de contacto en la parte inferior de
            esta declaración de cookies. Si tiene alguna queja sobre cómo
            manejamos sus datos, nos gustaría saber de usted, pero también tiene
            derecho a presentar una queja a la auto ridad supervisora (la
            Autoridad de Protección de Datos)
          </p>
        </el-collapse-item>
        <el-collapse-item name="9">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i
            >Habilitación/deshabilitación y eliminación de cookies
          </template>
          <p>
            Puede utilizar su navegador de Internet para eliminar las cookies de
            forma automática o manual. Usted también puede especificar que
            ciertas cookies no pueden ser colocadas. Otra opción es cambiar la
            configuración de su navegador de Internet para que reciba un mensaje
            cada vez que se coloca una cookie. Para obtener más información
            sobre estas opciones, consulte las instrucciones de la sección Ayuda
            de su navegador.
          </p>
          <p>
            Tenga en cuenta que nuestro sitio web puede no funcionar
            correctamente si todas las cookies están deshabilitadas. Si borra
            las cookies de su navegador, se volverán a colocar después de su
            consentimiento cuando vuelva a visitar nuestros sitios web.
          </p>
        </el-collapse-item>
        <el-collapse-item name="10">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>Detalles de contacto
          </template>
          <p>
            Para preguntas y/o comentarios sobre nuestra política de cookies y
            esta declaración, póngase en contacto con nosotros utilizando los
            siguientes datos de contacto:
          </p>
          <div class="no-padding">
            <p>
              Denominación:
              <b class="font-blod">MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
            </p>
            <p>
              Inscrita en el
              <b class="font-blod"
                >Registro Mercantil en el tomo 40665 folio 70 hoja</b
              >
            </p>
            <p>
              M-721662. Dirección:
              <b class="font-blod"
                >CALLE GÜNTER, 1, 28906 GETAFE, </b
              >
            </p>
            <p>
              MADRID Website:
              <b class="font-blod">HTTPS://MARAGONCONSTRUCCION.ES/</b>
            </p>
          </div>
          <div class="no-padding">
            <p>
              Email:
              <el-link type="primary"  href="mailto:info@maragonconstruccion.es">info@maragonconstruccion.es</el-link>
            </p>
            <p>
              Número de teléfono:
              <el-link type="primary" href="tel:603440332"> 603 440 332</el-link>
            </p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </pageContent>
</template>

<script>
import pageContent from "@/components/pageContent.vue"
export default {
  name: "cookies",
  components: {
    pageContent,
  },
  data() {
    return {
      activeNames: 0,
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.cookies-main {
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  top: -220px;
  .row-text {
    text-align: center;
    color: #fff;
    margin-bottom: 100px;

    .font-blod {
      font-size: calc(var(--font-size) * 3);
    }
  }
  .i {
    font-style: italic;
    font-size: calc(var(--font-size) - 4px);
  }
  .table{
    width: 100%;
    border-left: #000000 1px solid;
    border-top: #000000 1px solid;
    td,th{
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 30px;
      padding-bottom: 30px;
      font-size:calc( var(--font-size) - 12px);
      border-right: #000000 1px solid;
      border-bottom: #000000 1px solid;
    }
  }
}
.collapse {
  margin-top: 120px;
}
</style>
